import React from "react";
/** composants **/
import GoogleAvis2 from '../img/google-avis-2.png';



function GoogleAvis(args) {

    return (
        <div>
            <div className="flex gap-2 items-center  justify-center">
                <img src={GoogleAvis2} className="w-32" alt="Avis Clotere - simplifier votre passage chez le notaire" />
                <p className="m-0 text-sm font-bold">5 | <a target="blank" href="https://www.google.com/search?sca_esv=d214253f9e079b85&hl=fr&authuser=0&q=Clotere&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZDzCaQ6PPw1Mgvvzif6RPDbzlyvfgpBpItJUodOtpKTPaOfRqxPnJiVlFGA37fDf9TtdoQ%3D&uds=ABqPDvysoTTq_vp6PiQY3u-nn8x5mrrThE-WixzhGgTgcP_mlCE3-A4gQLqOtz9y4LiiTIbfFBKkE3gMtki_Kkb4BD_mskaVaRvCLgFEWxykHDgiwrX4QIM&sa=X&ved=2ahUKEwjSoubx5s2MAxUaTqQEHXPXOdUQ3PALegQIGhAE&biw=1511&bih=765&dpr=2" className="text-black !font-normal">8 avis</a></p>
            </div>
        </div>
    );
}

export default GoogleAvis;